import builder from '../builder';
import Check from '../../streamline-icons/bold/check.svg';

export default builder('IconCheckBold', Check);
